import React from "react";
import { ArrowUpNarrowWide, ArrowDownWideNarrow } from "lucide-react";

const KEY = "jobs_time_sort";

// Returns the saved preference or null — each view applies its own default.
export const readJobSortPref = () => {
  try { return localStorage.getItem(KEY) || localStorage.getItem("jobs_calendar_sort") || null; } catch { return null; }
};

export const writeJobSortPref = (v) => {
  try {
    localStorage.setItem(KEY, v);
    localStorage.setItem("jobs_calendar_sort", v);
  } catch { /* ignore */ }
};

export const getScheduledMs = (job) => {
  if (!job.scheduled_date) return null;
  const d = new Date(job.scheduled_date);
  if (isNaN(d.getTime())) return null;
  const st = (job.scheduled_time || "").trim();
  if (st) {
    const ampm = st.match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
    if (ampm) {
      let h = parseInt(ampm[1], 10);
      const m = parseInt(ampm[2], 10);
      const p = ampm[3].toUpperCase();
      if (p === "PM" && h < 12) h += 12;
      if (p === "AM" && h === 12) h = 0;
      const base = new Date(d); base.setHours(h, m, 0, 0);
      return base.getTime();
    }
    const h24 = st.match(/^(\d{1,2}):(\d{2})$/);
    if (h24) {
      const base = new Date(d); base.setHours(parseInt(h24[1], 10), parseInt(h24[2], 10), 0, 0);
      return base.getTime();
    }
  }
  return d.getTime();
};

// Comparator by scheduled date+time; jobs without a schedule sort last.
export const compareBySchedule = (dir) => (a, b) => {
  const aMs = getScheduledMs(a);
  const bMs = getScheduledMs(b);
  if (aMs === null && bMs === null) return 0;
  if (aMs === null) return 1;
  if (bMs === null) return -1;
  if (aMs !== bMs) return dir * (aMs - bMs);
  return dir * (new Date(a.created_at || 0) - new Date(b.created_at || 0));
};

export const JobSortToggle = ({ sortOrder, onToggle, testId }) => (
  <button
    type="button"
    onClick={onToggle}
    title={sortOrder === "asc" ? "Earliest jobs first — click for latest first" : "Latest jobs first — click for earliest first"}
    className="flex items-center gap-1 text-[10px] font-medium text-muted-foreground hover:text-foreground bg-theme-surface hover:bg-theme-hover border border-border/40 px-2 py-0.5 rounded-full transition-colors whitespace-nowrap"
    data-testid={testId}
  >
    {sortOrder === "asc" ? <ArrowUpNarrowWide className="w-3 h-3" /> : <ArrowDownWideNarrow className="w-3 h-3" />}
    {sortOrder === "asc" ? "Earliest first" : "Latest first"}
  </button>
);
